<template>
  <div class="messenger-container">
    <!--    <b-loading :is-full-page="false" :active="!isGotchiConnected || isConversationsLoading" />-->
    <div class="messenger" :class="[`conversation-details-${conversationDetails}`]">
      <div class="messenger-tickets">
        <div class="header">
          <div class="is-flex">
            <template v-if="user?.firstName">
              <Avatar size="size32" status="green" :name="user.firstName + ' ' + user.lastName " :src="user?.avatar" />
            </template>
            <template v-else-if="user?.displayName">
              <Avatar size="size32" status="green" :name="user?.displayName" :src="user?.avatar" />
            </template>
            <template v-else>
              <user-filled-icon class="icon" />
              <h4 class="title">
                {{ $t('messenger.title') }}
              </h4>
            </template>
          </div>
          <button class="new-message" :disabled="isConversationLimitReached" @click="handleOpenNewConversation">
            {{ $t('messenger.newTicket.new') }}
          </button>
          <div v-if="isConversationLimitReached" class="box-red">
            <p>{{ $t('messenger.conversationLimitReached', { max: MAX_CONVERSATIONS }) }}</p>
          </div>
          <!-- <div v-else-if="!user" class="box-red">
            <p>{{ $t('messenger.loginBenefits') }}</p>
          </div> -->
        </div>
        <!--        <div class="history desktop">-->
        <!--          <div class="is-flex">-->
        <!--            <p>{{ $t('messenger.unreadMessage') }}</p>-->
        <!--            <span class="badge">0</span>-->
        <!--          </div>-->

        <!--          <b-input-->
        <!--            size="small"-->
        <!--            name="search"-->
        <!--            :placeholder="$t('fields.search')"-->
        <!--            @input="searchConversations"-->
        <!--          />-->
        <!--        </div>-->

        <div ref="conversationContainerRef" class="container-scroll">
          <!--        <div class="history is-mobile">-->
          <!--            <div class="is-flex">-->
          <!--              <p>{{ $t('messenger.unreadMessage') }}</p>-->
          <!--              <span class="badge">0</span>-->
          <!--            </div>-->
          <!--            <b-input-->
          <!--              size="small"-->
          <!--              name="search"-->
          <!--              :placeholder="$t('fields.search')"-->
          <!--              @input="searchConversations"-->
          <!--            />-->
          <!--          </div> -->
          <div class="message-box-wrapper">
            <message-box
              v-if="!isConversationLimitReached && draftConversation"
              :conversation="draftConversation"
              @handle-click="handleOpenConversation(draftConversation.conversationId)"
            />
            <template v-if="conversations?.items?.length > 0">
              <read-sentinel v-if="conversations?.items?.length >= FETCH_CONVERSATIONS_LIMIT" tag="div" position="up" margin="100" @visible="handleTopSentinel" />
              <message-box
                v-for="(conversation) in conversations.items"
                :key="conversation?.conversationId"
                :conversation="conversation"
                @handle-click="handleOpenConversation(conversation?.conversationId)"
              />
              <read-sentinel v-if="conversations?.items?.length >= FETCH_CONVERSATIONS_LIMIT" tag="div" position="down" margin="100" @visible="handleBottomSentinel" />
            </template>
            <template v-else-if="isConversationsLoading">
              <b-skeleton v-for="(_, idx) in 5" :key="idx" height="130px" :active="true" />
            </template>
          </div>
        </div>
      </div>

      <template v-if="mainMessenger.isConversationOpened">
        <div class="messenger-conversation">
          <conversation-skeleton-header v-if="isConversationLoading" />
          <div v-else class="top">
            <button class="icon-button icon-back" @click="handleCloseConversation">
              <arrow-left-icon />
            </button>

            <avatar size="size32" :src="iconType" contain :name="ticketName ? ticketName : $t('messenger.newTicket.general')" status="green" />
            <div class="tag">
              {{ ticketType ? $t(`messenger.labels.${ticketType}`) : $t('messenger.labels.general') }}
            </div>
          </div>
          <Conversation ref="chatBoxComponent" :conversation="conversation" />
          <message-area @send="handleSend" />
        </div>
      </template>

      <div v-else class="messenger-illustration">
        <illustration-icon />
        <p>{{ $t('messenger.selectTicketFromTheList') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import { FETCH_CONVERSATIONS_LIMIT, MAX_CONVERSATIONS } from '../config/global'
import { lockBodyScroll } from '../../../utils/bodyScrollLock'
import ArrowLeftIcon from '../../../assets/generate-icons/icons/arrow-left.svg?inline'
import IllustrationIcon from '../../../assets/illustrations/conversation-choose-ticket.svg?inline'
import UserFilledIcon from '../../../assets/generate-icons/icons/user-filled.svg?inline'
import productIcon from '../../../assets/generate-icons/gotchi/product.svg'
import orderIcon from '../../../assets/generate-icons/gotchi/order.svg'
import schuetteIcon from '../../../assets/generate-icons/gotchi/schuette.svg'
import rzaskaIcon from '../../../assets/generate-icons/gotchi/rzaska.svg'
import debounce from '../../../utils/debounce'
import Conversation from '../Conversation.vue'
import Avatar from '../Avatar.vue'
import ReadSentinel from '../ReadSentinel.vue'
import { ConversationTypes } from '../config/ConversationTypes'
import { createOptimisticConversation } from '../config/optimistic'
import deferredLoading from '../../../utils/deferredLoading'
import Box from './Box.vue'
import Area from './Area.vue'
import ConversationSkeletonHeader from './ConversatiionSkeleonHeader.vue'
export default {
  components: { IllustrationIcon, ArrowLeftIcon, UserFilledIcon, MessageArea: Area, Conversation, MessageBox: Box, Avatar, ReadSentinel, ConversationSkeletonHeader },
  provide: {
    layout: 'full',
    isAlone: true,
    displayOne: false
  },
  data () {
    return {
      FETCH_CONVERSATIONS_LIMIT,
      MAX_CONVERSATIONS,
      schuetteIcon,
      rzaskaIcon,
      productIcon,
      orderIcon,
      previousHeight: null,
      isFetching: false,
      conversationDetails: false,
      isUserNearBottom: false,
      isConversationsLoading: false,
      isConversationLoading: false
    }
  },
  computed: {
    ...mapGetters('gotchiClient', [
      'hasDraftConversation',
      'draftConversation',
      'gotchiMessages',
      'cursorConversation'
    ]),
    ...mapState('gotchiClient', [
      'conversation',
      'conversations',
      'activeReply',
      'lastMessageId',
      'lastConversationId',
      'mainMessenger'
    ]),
    ticketName () {
      return !this.conversation?.title ? this.$route.query?.title : this.conversation?.title
    },
    ticketType () {
      return this.conversation?.labels.type
    },
    generalIcon () {
      return this.project === 'rzaska' ? this.rzaskaIcon : this.schuetteIcon
    },
    iconType () {
      if (this.ticketType === ConversationTypes.PRODUCT) { return this.productIcon }
      if (this.ticketType === ConversationTypes.ORDER) { return this.orderIcon }
      return this.generalIcon
    },
    isConversationLimitReached () {
      return !this.user && this.conversations?.items?.length >= this.MAX_CONVERSATIONS
    }
  },
  watch: {
    '$route.query.conversationId': {
      immediate: true,
      handler (conversationId) {
        if (!conversationId) { return }
        deferredLoading(async () => {
          if (conversationId === ConversationTypes.NEW_CONVERSATION) {
            this.handleNewConversationRoute()
          } else if (this.conversation?.conversationId !== conversationId) {
            try {
              await this.toggleConversation({ conversationId })
            } catch (e) {
              await this.$router.replace({ query: { ...this.$route.query, conversationId: ConversationTypes.NEW_CONVERSATION } })
              return
            }
          }
          this.toggleMainConversation(true)
        }, (v) => { this.isConversationLoading = v })
      }
    }
  },
  mounted () {
    const query = this.$route.query.conversationId

    this.toggleMainMessenger()

    if (!query && this.conversations?.items?.length === 0 && !this.hasDraftConversation) {
      this.handleOpenNewConversation()
    } else if (!query && this.conversation?.conversationId) {
      this.handleOpenConversation(this.conversation?.conversationId)
    }

    this._unlockBodyScroll = lockBodyScroll()
  },
  destroyed () {
    this.handleCloseConversation()
    this._unlockBodyScroll()
  },
  methods: {
    ...mapActions('gotchiClient', [
      'getConversations',
      'setDraftConversation',
      'closeConversation',
      'toggleConversation',
      'submitMessage'
    ]),
    ...mapMutations('gotchiClient', ['toggleMainMessenger', 'toggleMainConversation', 'setConversation', 'clearReply']),

    handleNewConversationRoute () {
      if (!this.hasDraftConversation) {
        const optimistic = createOptimisticConversation({
          title: this.$t('messenger.newTicket.general'),
          labels: { type: ConversationTypes.GENERAL }
        })
        this.setDraftConversation(optimistic)
      } else if (this.draftConversation) {
        this.setConversation(this.draftConversation)
      }
    },

    async handleSend (message) {
      const { title, labels: { type } } = this.conversation
      this.$refs.chatBoxComponent?.scrollToLatestMessage()
      try {
        const response = await this.submitMessage({
          message: { replyTo: this.activeReply, ...message },
          meta: { type, title },
          onPushed: () => this.$refs?.chatBoxComponent?.scrollToBottom()
        })
        if (response?.conversationId) {
          const query = { ...this.$route.query, conversationId: response.conversationId }
          await this.$router.replace({ query })
        }
      } catch {}
    },
    handleOpenNewConversation () {
      if (this.isConversationLimitReached) { return }
      const optimistic = createOptimisticConversation({
        title: this.$t('messenger.newTicket.general'),
        labels: { type: ConversationTypes.GENERAL }
      })
      this.setDraftConversation(optimistic)
      this.setConversation(this.draftConversation)
      this.$router.push({ query: { conversationId: ConversationTypes.NEW_CONVERSATION } })
    },

    handleOpenConversation (conversationId) {
      this.$router.push({ query: { conversationId } })
    },
    handleCloseConversation (conversation) {
      this.$router.push({ query: { conversationId: undefined } })
      this.closeConversation(conversation)
      this.toggleMainConversation(false)
    },

    async handleTopSentinel (entry) {
      if (!entry.isIntersecting || this.isFetching) { return }
      await this.loadNewConversationList()
    },

    async handleBottomSentinel (entry) {
      this.isUserNearBottom = entry.isIntersecting
      if (!this.isUserNearBottom && this.isFetching) { return }
      await this.loadOldConversationList()
    },

    async loadOldConversationList () {
      this.isFetching = true
      const lastKnownId = this.conversations.items[this.conversations?.items?.length - 1]?.conversationId
      const response = await this.getConversations({ before: this.cursorConversation.before, limit: FETCH_CONVERSATIONS_LIMIT })
      if (response?.items?.length < 1) { return }
      await this.$nextTick()
      if (lastKnownId) {
        const lastEl = document.getElementById(lastKnownId)
        if (lastEl) {
          this.$refs.conversationContainerRef.scrollTop = lastEl.offsetTop - this.$refs.conversationContainerRef.clientHeight + lastEl.clientHeight
        }
      }
      this.isFetching = false
    },

    async loadNewConversationList () {
      this.isFetching = true
      const firstKnownId = this.conversations.items[0]?.conversationId
      const response = await this.getConversations({ after: this.cursorConversation.after, limit: FETCH_CONVERSATIONS_LIMIT })
      if (response?.items?.length < 1) { return }
      await this.$nextTick()
      if (firstKnownId) {
        const firstEl = document.getElementById(firstKnownId)
        if (firstEl) {
          this.$refs.conversationContainerRef.scrollTop = firstEl.offsetTop
        }
      }
      this.isFetching = false
    },

    searchConversations: debounce(function (search) {
      // TODO Czekam na backend
      console.log('searchConversations', search)
    }, 500)
  }
}
</script>

<style lang="scss" scoped>

.icon-button {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border: none;
  svg{
    transition: all 0.3s;
  }
  &:hover{
    svg{
      transform: scale(1.1);
    }
  }
}

.icon-back {
  display: none;

  @include touch {
    display: block;
  }
}

.message-box-wrapper {
  padding-left: 12px;
  padding-right: 18px;

  @include touch {
    padding-left: 24px;
    padding-right: 24px;
  }
}

.messenger {
  display: flex;
  height: calc(100vh - 275px);
  background-color: #F7F7F7;
  border-radius: 12px;
  overflow: hidden;
  padding: 24px;
  padding-left: 12px;
  padding-bottom: 0;
  position: relative;

  @include touch {
     height: calc(100vh - 98px);
     padding: 0;
  }
  .is-mobile {
    display: none;
    @include touch{
      display: block;
    }
  }
   .title{
      font-size: 20px;
      @include touch{
        font-size: 16px;
      }
    }
  .header{
    padding-left: 12px;
    padding-right: 24px;
    position: relative;
    margin-bottom: 20px;
    max-width: 100%;
    @include touch{
      padding: 16px 24px;
      height: 110px;
       :deep(svg){
        width: 28px !important;
        height: 28px !important;
      }
    }
    :deep(.avatar-container){
      gap: 12px;
      .avatar__name{
        font-size: 20px;
            @include touch{
              font-size: 16px;
        }
      }
      .avatar{
        @include touch{
          width: 28px;
          height: 28px;
          flex: 0 0 28px;
        }

      }
       @include touch{
        gap: 8px;
        }
    }
    .icon{
      width: 32px;
      height: 32px;
    }
    .box-red{
      background-color: #FFE1E1;
      padding: 16px 24px;
      border-radius: 12px;
      margin-top: 16px;
      font-size: 14px;
      @include touch{
        display: none;
      }
      p{
        color: $primary;
        font-weight: 400;
      }
    }

    .is-flex{
      align-items: center;
      gap: 12px;
    }
  }
  .history{
    padding: 20px 24px 12px 12px;
    height: 110px;
    &.desktop{
      @include touch{
      display: none;
    }
    }
    @include touch{
      padding: 0 24px 12px 24px;
    }
        p{
      font-size: 14px;
      font-weight: 600;
    }
    .is-flex{
      align-items: center;
      gap: 8px;
    }
      .badge{
      height: 24px;
      min-width: 24px;
      padding: 0 7px;
      color: #7A7A7A;
      font-size: 14px;
      border-radius: 20px;
      background-color: white;
      display: flex;
      align-items: center;
      justify-content: center;
     }
    :deep(.control){
      input  {
      height: 36px;
      width: 100%;
      border-radius: 36px;
      box-shadow: 0 1px 7px rgba(50, 46, 103, 0.15);
      border: none;
      margin-top: 16px;
      @include touch{
        margin-top: 12px;
      }
    }
    }

  }
  .container-scroll {
     margin-right: 6px;
     overflow-y: auto;
     padding: 8px 0;
      display: flex;
      flex-direction: column;

      @include touch {
         height: 100%;
         padding-top: 16px;
         margin-right: 0;
      }
  }

  @include touch {
    border: 0;
    border-radius: 0;
    border-top: 1px solid grey;
  }

  .messenger-tickets {
    position: relative;
    flex-shrink: 0;
    height: 100%;
    width: 340px;
    display: flex;
    flex-direction: column;
    // padding-bottom: 24px;

    @include touch {
      width: 100dvw;
      height: calc(100dvh - 98px);
      //max-width: calc(100vw - 50px - 2px);
    }
    .new-message{
      background-color: white;
      border-radius: 29px;
      color: $primary;
      font-weight: 600;
      display: flex;
      justify-content: center;
      align-items: center;
      border: none;
      width: 100%;
      height: 36px;
      margin: 16px 0px;
      box-shadow: 0 1px 7px rgba(50, 46, 103, 0.15);
      transition: opacity 0.2s;
      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
         @include touch{
      margin-bottom: 0 ;
     }
     }
     :deep(.message-box):last-child{
      margin-bottom: 0;
     }

  }

  .messenger-details {
    position: relative;
    flex-shrink: 0;
    width: 340px;
    overflow: hidden;
    padding-left: 24px;
    p{
      font-weight: 600;
    }

    @include touch {
      width: 100%;
    }
  }
}
.messenger-conversation {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: white;
  height: calc(100vh - 320px);
  width: 30dvw;
  border-radius: 16px;
  padding-bottom: 24px;

  .tag{
    margin-left: auto;
    border-radius: 34px;
  }
  @include touch{
    position: absolute;
    top: 0;
    left: 0;
    z-index: 39;
    height: calc(100dvh - 80px);
    padding-bottom: 24px;
  }

  @include touch {
    width: 100dvw;
    border: 0;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .top{
    padding: 0 24px;
    border-bottom: 1px solid #DBDBDB;
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 0 0 auto;
    height: 73px;

    .back-button {
      cursor: pointer;
    }
    :deep(.avatar-container){
      width: 100%;
      .text{
        .clamp-text{
          font-size: 20px;
        }
      }
    }

    @include touch{
      height: 64px;
      > :deep(.avatar-container){
        .avatar{
          width: 28px;
          height: 28px;
          flex: 0 0 28px;
        }
        .text{
          max-width: 70% !important;
          .clamp-text{
            font-size: 14px !important;
          }
        }
      }
      :deep(svg){
        width: 30px;
      }

    }
    h3{
      font-size: 16px;
      font-weight: 600;
    }
  }
  :deep(.message-area){
    flex: 0 0 auto;
  }
}
.messenger-illustration {

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;
  height: 100%;
  color: rgba(49, 49, 49, .5);

  svg {
    max-width: 200px;
    height: auto;
  }
}
.messenger.mode-tickets {
  @include touch {
    .messenger-conversation,
    .messenger-details {
      display: none;
    }
  }
}

.messenger.mode-conversation {
  @include touch {
    .messenger-tickets,
    .messenger-details {
      display: none;
    }
  }
}

.messenger.conversation-details-true {
  @include touch {
    .messenger-tickets,
    .messenger-conversation {
      display: none;
    }

    .messenger-details {
      display: block !important;
    }
  }
}
</style>
